export const INTENTS_LOADING = 'INTENTS_LOADING';
export const INTENTS_RECEIVED = 'INTENTS_RECEIVED';
export const INTENTS_ERROR = 'INTENTS_ERROR';
export const ENTITIES_LOADING = 'ENTITIES_LOADING';
export const ENTITIES_RECEIVED = 'ENTITIES_RECEIVED';
export const ENTITIES_ERROR = 'ENTITIES_ERROR';
export const NLP_SNAPSHOT_UPDATING = 'NLP_SNAPSHOT_UPDATING';
export const NLP_SNAPSHOT_UPDATED = 'NLP_SNAPSHOT_UPDATED';
export const NLP_SNAPSHOT_UPDATION_ERROR = 'NLP_SNAPSHOT_UPDATION_ERROR';

// common actiontype for conversation and chat history
export const MESSAGE_NLP_SNAPSHOT_UPDATED = 'MESSAGE_NLP_SNAPSHOT_UPDATED';



// WEBPACK FOOTER //
// ./src/data/redux/nlp_details/actiontypes.js